import { render, staticRenderFns } from "./dangerHub.vue?vue&type=template&id=1763066c&scoped=true&"
import script from "./dangerHub.vue?vue&type=script&lang=js&"
export * from "./dangerHub.vue?vue&type=script&lang=js&"
import style0 from "./dangerHub.vue?vue&type=style&index=0&id=1763066c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1763066c",
  null
  
)

export default component.exports